module.exports = __webpack_public_path__ + "static/media/r2.fce91e8c.png";